import type { CSSProperties } from 'react';

const harmonyKeyframes = `
  @keyframes harmonyDraw {
    0% { stroke-dashoffset: 400; }
    50% { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: -400; }
  }
  @keyframes harmonyPulse {
    0%, 100% { opacity: 0.6; stroke-width: 3.5; }
    50% { opacity: 1; stroke-width: 4; }
  }
`;

export type IconHarmonyProps = {
  animated?: boolean;
  height?: number | string;
  style?: CSSProperties;
  width?: number | string;
};

export const IconHarmony = ({ animated = false, height = 23, style, width = 24 }: IconHarmonyProps) => (
  <>
    {animated ? <style>{harmonyKeyframes}</style> : null}
    <svg
      fill="none"
      height={height}
      style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08))', ...style }}
      viewBox="0 0 84 80"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.3667 33.723C38.0801 30.8756 31.1512 33.3894 31.7677 40.5435C32.6477 50.7713 49.3998 53.5323 55.4936 42.0565C61.3839 30.965 53.9043 17.4132 41.2557 17.4132C9.14031 17.4132 12.1872 59.0989 38.5111 63.4087C79.1776 70.0684 87.2588 2 41.3904 2C1.0561 2.00298 2.0019 37.3387 2.0019 37.3387C1.81334 85.9195 63.0151 89.1659 82 56.6656"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'harmonyDraw 2.5s ease-in-out infinite, harmonyPulse 2.5s ease-in-out infinite',
                strokeDasharray: 400,
                strokeDashoffset: 400,
              }
            : undefined
        }
      />
    </svg>
  </>
);
